import { EncryptionErrorCode } from "./encryptionTypes";
import { ENCRYPTION_ERROR_MAPPINGS } from "./encryptionMappings";

import type { ErrorContext } from "@/errors";
import { OakGoogleClassroomException } from "@/errors";

/**
 * Error handler for Encryption operations
 * Converts errors for more accurate handling and throws custom OakGoogleClassroomException
 *
 * @param error - The caught error from encryption/decryption operations
 * @param context - Context about where/why the error occurred
 * @param errorCode - Specific encryption error code (encryption_failed or decryption_failed)
 * @returns Never (always throws OakGoogleClassroomException)
 */
export function handleEncryptionError(
  error: unknown,
  context: ErrorContext,
  errorCode: EncryptionErrorCode,
): never {
  console.error(`[${context.service}] Error in ${context.operation}:`, error);

  let originalError: Error;

  if (error instanceof Error) {
    originalError = error;
  } else {
    originalError = new Error(String(error));
  }

  const encryptionErrorMapping = ENCRYPTION_ERROR_MAPPINGS[errorCode];

  console.error(
    `[Internal] Error from Encryption: ${encryptionErrorMapping.internalMessage}`,
    {
      code: errorCode,
      operation: context.operation,
      metadata: context.metadata,
    },
  );

  throw new OakGoogleClassroomException(
    encryptionErrorMapping.userMessage,
    context.service,
    {
      code: errorCode,
      shouldRetry: encryptionErrorMapping.shouldRetry,
      severity: encryptionErrorMapping.severity,
      context,
      originalError,
    },
  );
}
